import { Routes } from '@angular/router';
import { Features, Permissions } from './shared/enum/FeaturePermissions';
import { AuthGuard } from './authentication/guard/auth.guard';
import { RoleGuard } from './authentication/guard/role-guard.service';
import { UnsavedChangesGuard } from './shared/guards/unsaved-changes.guard';
import { AppLayoutComponent } from './layout/app-layout/app-layout.component';
import { PublicLayoutComponent } from './layout/public-layout/public-layout.component';
import { AuthLayoutComponent } from './layout/auth-layout/auth-layout.component';
import { docHubHandoffFrameGuard } from './shared/customer-docs/doc-hub-handoff.guard';

export const routes: Routes = [
  {
    // Doc hub hand-off: no app layout, since it can also load inside the documentation drawer's iframe.
    path: 'kh-handoff',
    canActivate: [docHubHandoffFrameGuard, AuthGuard],
    loadComponent: () =>
      import('./shared/customer-docs/doc-hub-handoff.component').then((m) => m.DocHubHandoffComponent),
  },
  {
    path: 'kh-handoff/signed-out',
    data: { signedOut: true },
    loadComponent: () =>
      import('./shared/customer-docs/doc-hub-handoff.component').then((m) => m.DocHubHandoffComponent),
  },
  {
    path: '',
    component: AuthLayoutComponent,
    loadChildren: () => import('./authentication/authentication.routes').then((m) => m.AUTH_ROUTES),
  },
  {
    path: 'legal',
    component: PublicLayoutComponent,
    loadChildren: () => import('./public/legal/public.routes').then((m) => m.PUBLIC_ROUTES),
  },
  {
    path: '',
    component: AppLayoutComponent,
    canActivate: [AuthGuard],
    canActivateChild: [AuthGuard],
    children: [
      {
        path: 'suppliers',
        data: { feature: Features.Supplier, actions: [Permissions.Read] },
        canActivate: [RoleGuard],
        loadChildren: () => import('./suppliers/suppliers.routes').then((m) => m.SUPPLIER_ROUTES),
      },
      {
        path: 'approval-matrix-request',
        data: { feature: Features.Approval, actions: [Permissions.Read] },
        canActivate: [RoleGuard],
        loadChildren: () =>
          import('./approval-matrix-request/approval-matrix-request.routes').then(
            (m) => m.APPROVAL_MATRIX_REQUEST_ROUTES
          ),
      },
      {
        path: 'approval-matrix-section-based',
        data: { feature: Features.Approval, actions: [Permissions.Read] },
        canActivate: [RoleGuard],
        loadChildren: () =>
          import('./approval-matrix-section-based/approval-matrix-section-based.routes').then(
            (m) => m.APPROVAL_MATRIX_SECTION_BASED_ROUTES
          ),
      },
      {
        path: 'auditing',
        data: { feature: Features.Auditing, actions: [Permissions.Read] },
        canActivate: [RoleGuard],
        loadChildren: () => import('./auditing/auditing.routes').then((m) => m.AUDITING_ROUTES),
      },
      {
        path: 'reporting',
        data: { feature: Features.Reporting, actions: [Permissions.Read] },
        canActivate: [RoleGuard],
        loadChildren: () => import('./reporting/reporting.routes').then((m) => m.REPORTING_ROUTES),
      },
      {
        path: 'users',
        data: { feature: Features.User, actions: [Permissions.Read, Permissions.readSupplier] },
        canActivate: [RoleGuard],
        loadChildren: () => import('./users/users.routes').then((m) => m.USERS_ROUTES),
      },
      {
        path: 'my-profile',
        canDeactivate: [UnsavedChangesGuard],
        loadComponent: () =>
          import('./authentication/my-profile/my-profile.component').then((m) => m.MyProfileComponent),
      },
      {
        path: 'requests',
        data: { feature: Features.Request, actions: [Permissions.Read, Permissions.ReadOwn] },
        canActivate: [RoleGuard],
        loadChildren: () => import('./requests/requests.routes').then((m) => m.REQUEST_ROUTES),
      },
      {
        path: '',
        loadChildren: () => import('./form/forms.routes').then((m) => m.FORMS_ROUTES),
      },
    ],
  },

  { path: '**', redirectTo: 'login' },
];
